export default "__VITE_ASSET__DhM0_X1g__"